import { TYPE_COLLECTION } from './input-types';

export const id = 'createdBy';
export const apiKey = 'assignedToId';
export const type = TYPE_COLLECTION;

export const createdBy = {
  id,
  apiKey,
  type,
};
